var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3987 22.7974C17.694 22.7974 22.7974 17.694 22.7974 11.3987C22.7974 5.10338 17.694 0 11.3987 0C5.10338 0 0 5.10338 0 11.3987C0 17.694 5.10338 22.7974 11.3987 22.7974ZM10.8768 19.2654C11.0851 19.5842 11.2963 19.9077 11.5111 20.2401C11.5802 20.1773 11.6329 20.1363 11.6728 20.1053C11.7246 20.0651 11.7547 20.0417 11.771 20.0091C12.2048 19.3191 12.6395 18.6298 13.074 17.9408C14.476 15.7176 15.8764 13.4969 17.2432 11.2594C18.0517 9.93107 18.2394 8.45835 17.8929 6.94231C17.2865 4.27119 15.6261 2.55302 12.9694 1.96104C10.3127 1.36906 8.01699 2.19205 6.38544 4.37226C4.78277 6.52359 4.56619 8.92038 5.90897 11.2739C6.81859 12.8765 7.80131 14.4305 8.78403 15.9844C9.1116 16.5024 9.43918 17.0204 9.76404 17.5401C10.1277 18.1182 10.4973 18.6842 10.8768 19.2654ZM14.4565 8.21289C14.4565 9.80113 13.1571 11.0717 11.54 11.0717C9.96618 11.0573 8.68116 9.81556 8.66672 8.24177C8.65228 6.68242 9.98062 5.3252 11.54 5.3252C13.0993 5.3252 14.4565 6.65354 14.4565 8.21289Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.87a81f8cd433ec9eb2bb3391fe962776.svg";
export { ForwardRef as ReactComponent };